import { APIMeta } from "./base";
import { CategoryType } from "./categories";

export interface TransactionsResponse {
  transactions: Transaction[];
  meta: APIMeta;
}
export interface APITransactionsResponse {
  transactions: APITransaction[];
  meta: APIMeta;
}
export interface APITransaction {
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
  deleted_at: string | null;
  type: "income" | "expense";
  amount: number;
  tax: number;
  adjustment: number;
  invoice_number?: string;
  approval_status: APITransactionApprovalStatus;
  description?: string;
  category?: {
    name: string;
    color: string;
    id: number;
    group?: {
      name: string;
    };
  };
  branch?: {
    id: number;
    name: string;
  };
  department?: {
    id: number;
    name: string;
  };
  contact?: {
    id: number;
    name: string;
  };
  account?: {
    id: number;
    name: string;
    number: number;
  };
  org_id: number;
  id: number;
  group_id: number;
  timestamp: string;
  version: number;
  updated_by: string;
  images?: TransactionFile[];
  branch_id: number | null;
  department_id: number | null;
  payment_method: APIPaymentMethod;
  tags: string[];
  company_id: number;
}

export interface APIPutTransaction {
  timestamp: string;
  amount: number | null;
  tax: number | null;
  adjustment: number | null;
  description: string;
  invoice_number?: string;
  type: "income" | "expense";
  approval_status?: APITransactionApprovalStatus;
  account_id: number | null;
  branch_id: number | null;
  department_id: number | null;
  category_id: number | null;
  payment_method: APIPaymentMethod;
  contact_id: number | null;
  tags: string[];
}

export enum APITransactionApprovalStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export enum TransactionApprovalStatus {
  PENDING = "Pendiente",
  APPROVED = "Aprobado",
  REJECTED = "Rechazado",
}

export interface Transaction {
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  deletedAt: string | null;
  branchId: number | null;
  branchName: string | null;
  departmentId: number | null;
  departmentName: string | null;
  approvalStatus?: TransactionApprovalStatus;
  companyId: number;
  account?: {
    id: number;
    name: string;
    number: number;
  };
  type: "Ingreso" | "Gasto";
  amount: number | null;
  tax: number | null;
  adjustment: number | null;
  invoiceNumber?: string;
  total: number;
  description: string;
  category?: string;
  categoryGroup?: string;
  categoryId?: number;
  categoryColor?: string;
  orgId: number;
  id: number;
  groupId: number;
  timestamp: string;
  version: number;
  updatedBy: string;
  files?: TransactionFile[];
  paymentMethod: PaymentMethod;
  contact?: {
    id: number;
    name: string;
  };
  tags: string[];
}

export enum APIPaymentMethod {
  CASH = "cash",
  BANK = "bank",
  CREDIT_CARD = "credit_card",
}

export enum PaymentMethod {
  CASH = "Efectivo",
  BANK = "Banco",
  CREDIT_CARD = "Tarjeta de crédito",
}

export interface PostTransaction {
  timestamp: Date;
  amount: number | null;
  tax: number | null;
  adjustment: number | null;
  invoiceNumber: string | null;
  description: string;
  type: CategoryType.EXPENSE | CategoryType.INCOME;
  branchId: number | null;
  departmentId: number | null;
  approvalStatus: TransactionApprovalStatus;
  categoryId: number | null;
  accountId: number | null;
  paymentMethod: APIPaymentMethod;
  contactId: number | null;
  debtId: number | null;
  employeeId?: number | null;
  tags: string[];
}
export interface TransactionFile {
  id: number;
  image_url: string;
  content_type: string;
  presigned_url: string;
}

export interface CategorySpending {
  category_id: number;
  category_name: string;
  category_color: string;
  group?: string;
  total_amount: number;
  percentage_of_total: number;
  transaction_count: number;
  subcategories?: CategorySpending[];
}

export interface DepartmentSpending {
  department_id: number;
  department_name: string;
  total_amount: number;
  transaction_count: number;
  transactions: APITransaction[];
}

export interface TransactionsSummary {
  income: number;
  expenses: number;
  net_amount: number;
  cash_income: number;
  cash_expenses: number;
  bank_income: number;
  bank_expenses: number;
  credit_card_income: number;
  credit_card_expenses: number;
}

export interface TimeSeries {
  date: string;
  income: number;
  expenses: number;
}
